import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { isNil } from 'ramda'

import type { SectionsRightImageComponent } from '@twisto/api-cms'

import { Hidden } from 'homepage/components/atoms/hidden'

import { StrapiMedia } from '../../atoms'
import { HeroDescription } from '../hero/hero-description'
import { HeroTitle } from '../hero/hero-title'

import * as styles from './right-image.styles'

export const RightImage = ({
  title,
  highlightedTitle,
  description,
  highlightedDescription,
  image,
  cta,
}: SectionsRightImageComponent) => (
  <section css={styles.section}>
    <Hidden breakpoint="smDown">
      <div css={styles.imageWrapper}>
        {!isNil(image?.url) && <StrapiMedia {...image} />}
      </div>
    </Hidden>
    <div css={styles.rightPanel}>
      <div css={styles.content}>
        {title && (
          <HeroTitle
            highlighted={highlightedTitle}
            title={title}
            variant="h2"
          />
        )}
      </div>
      <Hidden breakpoint="smUp">
        <div css={styles.imageWrapper}>
          {!isNil(image?.url) && <StrapiMedia {...image} />}
        </div>
      </Hidden>
      <div css={styles.content}>
        {description && (
          <HeroDescription
            description={description}
            highlighted={highlightedDescription}
          />
        )}
      </div>
      {cta?.link && cta.text && (
        <TextButton css={styles.cta} href={cta.link} size="large">
          {cta.text}
        </TextButton>
      )}
    </div>
  </section>
)
